import React, { useEffect, useState } from "react";
import { MenuItem, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AdminOrganization } from "src/Types/auth.types";
import { getAdminOrganizations } from "src/utils/apicalls";

const OWN_WORKSPACE = "__own__";

interface WorkspaceSwitcherProps {
  value: string | null;
  onChange: (workspaceKey: string | null) => void;
}

const WorkspaceSwitcher: React.FC<WorkspaceSwitcherProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();
  const [organizations, setOrganizations] = useState<AdminOrganization[]>([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    getAdminOrganizations()
      .then((result) => {
        if (active) setOrganizations(result);
      })
      .catch(() => {
        if (active) setError(true);
      });
    return () => {
      active = false;
    };
  }, []);

  const selected = value ?? OWN_WORKSPACE;

  return (
    <TextField
      select
      size="small"
      label={t("dashboard.workspace.label")}
      value={selected}
      onChange={(event) =>
        onChange(event.target.value === OWN_WORKSPACE ? null : event.target.value)
      }
      error={error}
      helperText={error ? t("dashboard.workspace.loadError") : undefined}
      sx={{ minWidth: { xs: 140, sm: 220 }, maxWidth: 280 }}
    >
      <MenuItem value={OWN_WORKSPACE}>{t("dashboard.workspace.own")}</MenuItem>
      {value && !organizations.some((org) => org.workspaceKey === value) && (
        <MenuItem value={value}>{value}</MenuItem>
      )}
      {organizations.map((organization) => (
        <MenuItem key={organization.id} value={organization.workspaceKey}>
          {organization.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default WorkspaceSwitcher;
